import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { bookItAgainStartupStepDefinition } from "../BookItAgain/BookItAgainStartup";
import { checkoutStepDefinition } from "../CheckoutPage/CheckoutStartup";
import { DestinationsStartupStepDefinition } from "../Destinations/DestinationsStartup";
import { FavouriteDepartureStartupStepDefinition } from "../FavouriteDeparture/FavouriteDepartureStartup";
import { mainBookingStepDefinition } from "../MainBookingFlow/MainBookingStartupFlow";
import { homeBannerWidgetStepDeclaration } from "./Steps/BannerWidgetStep";
import { departureFromStepDeclaration } from "./Steps/DepartureFromStep";
import { enhancedTripsStepDeclaration } from "./Steps/EnhancedTripsStep";
import { favouriteDeparturesStepDeclaration } from "./Steps/FavouriteDeparturesStep";
import { favouriteTripsStepDeclaration } from "./Steps/FavouriteTripsStep";
import { homePageInitStepDeclaration } from "./Steps/HomePageInitStep";
import { newsWidgetStepDeclaration } from "./Steps/NewsWidgetStep";
import { popularTripsStepDeclaration } from "./Steps/PopularTripsStep";
import { routesStepDeclaration } from "./Steps/RoutesStep";
import { trustBuilderStepDeclaration } from "./Steps/TrustBuilderStep";
import { usefulInformationStepDeclaration } from "./Steps/UsefulInformationStep";
import { HomePageTransition } from "./Transition/HomePageTransition";

export const homePageMainStartupFlow = new FlowDefinition("HomePageFlow");

homePageMainStartupFlow.addStep(homeBannerWidgetStepDeclaration);
homePageMainStartupFlow.addStep(homePageInitStepDeclaration);
homePageMainStartupFlow.addStep(mainBookingStepDefinition);
homePageMainStartupFlow.addStep(bookItAgainStartupStepDefinition);
homePageMainStartupFlow.addStep(FavouriteDepartureStartupStepDefinition);
homePageMainStartupFlow.addStep(DestinationsStartupStepDefinition);
homePageMainStartupFlow.addStep(usefulInformationStepDeclaration);
homePageMainStartupFlow.addStep(routesStepDeclaration);
homePageMainStartupFlow.addStep(trustBuilderStepDeclaration);
homePageMainStartupFlow.addStep(newsWidgetStepDeclaration);
homePageMainStartupFlow.addStep(enhancedTripsStepDeclaration);
homePageMainStartupFlow.addStep(favouriteTripsStepDeclaration);
homePageMainStartupFlow.addStep(favouriteDeparturesStepDeclaration);
homePageMainStartupFlow.addStep(checkoutStepDefinition);
homePageMainStartupFlow.addStep(popularTripsStepDeclaration);
homePageMainStartupFlow.addStep(departureFromStepDeclaration);

homePageMainStartupFlow.addLink("HomeStartupInit_Step", "HomeBannerWidgetStep")
homePageMainStartupFlow.addLink("HomeStartupInit_Step", "MainBookingFlow")
homePageMainStartupFlow.addLink("HomeStartupInit_Step", "BookItAgainFlow")
homePageMainStartupFlow.addLink("HomeStartupInit_Step", "DestinationsFlow")
homePageMainStartupFlow.addLink("HomeStartupInit_Step", "FavouriteDepartureFlow")
homePageMainStartupFlow.addLink("HomeStartupInit_Step", "UsefulInformationStep")
homePageMainStartupFlow.addLink("HomeStartupInit_Step", "RoutesStep")
homePageMainStartupFlow.addLink("HomeStartupInit_Step", "TrustBuilderStep")
homePageMainStartupFlow.addLink("HomeStartupInit_Step", "NewsWidgetStep")
homePageMainStartupFlow.addLink("HomeStartupInit_Step", "EnhancedTripsStep")
homePageMainStartupFlow.addLink("HomeStartupInit_Step", "FavouriteTripsStep")
homePageMainStartupFlow.addLink("HomeStartupInit_Step", "PopularTripsStep");
homePageMainStartupFlow.addLink("HomeStartupInit_Step", "DepartureFromStep");

homePageMainStartupFlow.addTransition(HomePageTransition, "HomeStartupInit_Step")

homePageMainStartupFlow.setStartStep("HomeStartupInit_Step");